import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ec2b417"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "countersign" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "请您确认签名是本人照片", -1))
const _hoisted_3 = ["src"]

import { computed, defineComponent, getCurrentInstance, nextTick, onMounted, reactive, toRefs, ref } from 'vue';
    import tabbar from "src/components/common/tabbar";
    import { Toast } from 'vant';
    import JSEncryptUtils from 'utils/encrypt-utils';
    import dayjs from 'dayjs';
    import { QuestionnaireService } from 'src/services';
    import {useToken } from 'src/store';
    import { useRouter, useRoute } from 'vue-router';
    import patterns from "src/utils/patterns";
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    let state = reactive({
        taskId: null,
        photh: null
    })
    onMounted(()=>
    {
        if(route.query.id)
        {
            state.taskId = route.query.id;
        }
        getVideoPhoth();
    })


    // 确认
    const onConfirm = () =>
    {
        router.replace({name: "sign", query:{id: state.taskId + ''}});
    }

    // 返回
    const onBack = () =>
    {
        router.replace({name: "home"});
    }

    // 获取人脸图片
    const getVideoPhoth = async () : Promise<void> =>
    {
        try
        {
            let {content: reslut} = await QuestionnaireService.instance.getVideoPhoth(state.taskId);
            if(reslut)
            {
                state.photh = reslut.data;
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(state).photh)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: `data:image/png;base64,${_unref(state).photh}`
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", { class: "btn-list" }, [
      _createElementVNode("button", {
        class: "btn-primary",
        onClick: onConfirm
      }, "确认"),
      _createElementVNode("button", {
        class: "btn-cancel van-hairline--surround face-reset",
        onClick: onBack
      }, "返回")
    ])
  ]))
}
}

})